import { FC, Suspense } from 'react'
import { Button } from '@cargomart/ui'
import { Outlet, useNavigate } from '@tanstack/react-router'
import cn from 'classnames'
import { Seo } from 'components'
import { Link } from 'components/extend/Link'
import { Logo } from 'components/extend/Logo'
import { IconSpinner } from 'components/IconSpinner'
import { MainWarning } from 'components/MainWarning'
import { LANDING_ROOT_LINK } from 'constants/links'
import { authRoute } from 'modules/login/routes'
import * as features from 'utils/feature'

const GuestLayout: FC = () => {
  const currentYear = new Date().getFullYear()
  const navigate = useNavigate()

  return (
    <div
      className={cn(
        'flex min-h-screen w-full flex-col bg-background',
        features.newYearLogo && "!bg-[url('assets/new-year-pattern.svg')]"
      )}
    >
      <Seo
        description="Личный кабинет пользователя сервиса QP5 Express."
        title="Вход в личный кабинет – сборные перевозки QP5 Express"
      />
      <MainWarning />
      {features.devFeatures && (
        <div className="fixed left-1 top-10 z-notice flex flex-col gap-y-2 bg-surface p-1 opacity-[0.8]">
          <Link to="/order/create">Гость создание заказа</Link>
          <Link to="/order-yarche-guest/create">Гость создание посылки</Link>
        </div>
      )}
      <div className="flex items-center justify-between p-4">
        <Logo
          isNative
          className=" width-[199px] height-[48px]"
          isNewYear={features.newYearLogo}
          link={LANDING_ROOT_LINK}
          type="adaptive"
        />
        <Button className="!min-h-[40px] !w-max !px-2 !py-1" onClick={() => navigate(authRoute)}>
          Войти
        </Button>
      </div>
      <div className="flex flex-grow flex-col items-center">
        <Suspense fallback={<IconSpinner size="lg" />}>
          <Outlet />
        </Suspense>
      </div>
      <div className="flex flex-none flex-col">
        <div className="flex min-h-[72px] max-w-screen-3lg items-center justify-between p-6 text-body-md">
          <span className="flex gap-5 text-center text-on-background">
            <a
              href={`${LANDING_ROOT_LINK}/tracking`}
              className="decoration-none relative text-on-surface-link after:absolute
              after:bottom-[calc(50%-2px)] after:right-[-12px] after:block after:h-1 after:w-1 after:rounded-full after:bg-on-surface-variant after:content-[''] hover:border-on-surface-link focus:border-on-surface-link
              "
            >
              Поиск по трек-номеру
            </a>
            <a
              href={`${LANDING_ROOT_LINK}/terminal`}
              className="decoration-none relative text-on-surface-link after:absolute
              after:bottom-[calc(50%-2px)] after:right-[-12px] after:block after:h-1 after:w-1 after:rounded-full after:bg-on-surface-variant after:content-[''] hover:border-on-surface-link focus:border-on-surface-link
              "
            >
              Адреса терминалов
            </a>
            <a
              className="decoration-none text-on-surface-link hover:border-on-surface-link focus:border-on-surface-link"
              href={`${LANDING_ROOT_LINK}/document`}
            >
              Документы
            </a>
          </span>
          <span className="mt-1 text-center">
            © 2021—{currentYear} АО «Корса»{' '}
            <span className="text-on-surface-variant">634034, г. Томск, пер. Инструментальный 51а, каб. 414</span>
          </span>
        </div>
      </div>
    </div>
  )
}

export default GuestLayout
